import React from 'react';
import { Button } from '@mui/material';

const RoundButton = ({ name, onClick, classname, disabled }) => {
  return (
    <Button
      sx={{
        fontSize: '17px',
        borderRadius: '27.5px !important',
        border: '2px solid #ffb91d',
        background: 'transparent',
        fontWeight: '400 !important',
        cursor: 'pointer',
        color: '#424242',
        width: '100%',
        lineHeight: '1.5 !important',
        display: 'inline-block',
        fontWeight: '400',
        textAlign: 'center',
        whiteSpace: 'inherit',
        verticalAlign: 'middle',
        textTransform: 'none',
        marginTop: '20px',
        '&:hover': {
          background: '#E9A100'
        },
        '@media (max-width:768px)': {
          whiteSpace: 'inherit'
        }
      }}
      className={classname}
      onClick={onClick}
      disabled={disabled}
    >
      {name}
    </Button>
  );
};
export default RoundButton;
